import {
    CHANGE_UNSAVED_CHANGES,
  } from '../actions/types';
  
  const initialState = { isUnsaved: false };

  function unsavedChanges (state = initialState, action) {
    switch (action.type) {
        case CHANGE_UNSAVED_CHANGES: {
            const { payload } = action;
            return { ...state, isUnsaved: payload };
        }
        default:
            return state;
    }
  }
  
  export { unsavedChanges as unsavedChangesReducer };